import React, { useEffect, useState } from "react";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { Card, CardBody, CardHeader, Col, Container, Row, Form, FormGroup, } from "reactstrap";
import { Formik } from "formik";
import { useNavigate, Link } from "react-router-dom";
import Attribute from "./Attribute";
import { useDispatch, useSelector } from "react-redux";
import { getAllService } from "../../../slices/services/thunk";
import { addService } from "../../../slices/services/addservice/thunk";
import { getConfig } from "../../../slices/services/addservice/eventconfiguration/thunk";
import { getAllAttribute } from "../../../slices/services/addservice/provisionalattribute/thunk";
import { ToastContainer } from "react-toastify";
import { EventOptions, getProvisionOptions, ServiceOptions, validationSchema, AttributeTypeOptions, getUsageOptions, } from "./constants/initialvalues";
import { createJsonObj } from "./constants/servicejson";
import { Loader } from "../../Utils/Loader";
import CommonButton from "../../Utils/CommonButton";
import { PAGE_TITLES } from "../../Common/constants";
import { RenderField } from "../../Utils/renderFields";
import { LabelText } from "../../Utils/Input";
import { customerIdData } from "../../Customers/constants/constantFunctionsView";
import { getServiceByCode } from "../../../slices/services/getservice/thunk";
import { editService } from "../../../slices/services/editservice/thunk";

export default function AddService(initialAIServiceValues) {
  const [state, setState] = useState(false);
  const [startDate, setStartDate] = useState();
  const [selectedAttributeName, setSelectedAttributeName] = useState(null);
  const [loading, setLoading] = useState("");
  const [title, setTitle] = useState()
  const [addserviceuse, setAddserviceuse] = useState()
  const [enableReinitialize, setEnableReinitialize] = useState(false)

  const isCreate = location.pathname.includes('create-service')
  const isEdit = location.pathname.includes('edit-service')
  const isClone = location.pathname.includes('clone-service')
  let navigate = useNavigate();
  const serviceCode = customerIdData()
  const isAiPath = location.pathname.includes('chatbot')
  let initialValues = {
    name: "",
    code: "",
    eventConfigurations: '',
    startsOn: null,
    endson: null,
    services: "",
    isBundle: false,
    description: "",
    attributeList: []
  };
  const [formInitialValues, setFormInitialValues] = useState(initialValues);
  const dateFormat = localStorage.getItem("dateFormat") || "DD MMM YYYY";

  const formFields = [
    {
      name: "name",
      placeholder: "", // Empty placeholder for input field
      helperText: "Enter Service Name", // Helper text for above the field
      type: "text",
      required: true,
      label: "Service Name",
      disable: false,
      className: "form-control"
    },
    {
      name: "code",
      placeholder: "", // Empty placeholder for input field
      helperText: "Enter Service Code", // Helper text for above the field
      type: "text",
      required: true,
      label: "Service Code",
      disable: false,
      className: "form-control"
    },
    {
      name: "eventConfigurations",
      placeholder: "", // Empty placeholder for select field
      helperText: "Select Event Configurations", // Helper text for above the field
      type: "select",
      required: true,
      label: "Event Configurations",
      className: "error-input",
      isMulti: true,
      disable: false,
      closeMenuOnSelect: false
    },

    {
      name: "isBundle",
      type: "switch",
      required: false,
      label: "Service Bundle",
      switchLabel: "Enable Service Bundle",
      customLayout: true
    },
    {
      name: "services",
      placeholder: "", // Empty placeholder for select field
      helperText: "Select Services", // Helper text for above the field
      type: "select",
      required: false,
      label: "Services",
      className: "error-input",
      isMulti: true,
      closeMenuOnSelect: false
    },
    {
      name: "startsOn",
      type: "date",
      views: ["year", "month", "day"],
      required: true,
      label: "Starts On",
      className: "error-input",
      secondClassName: "form-control",
      format: dateFormat,
      helperText: dateFormat, // Helper text for date format
      indicator: "start",
      minDate: true,
      useStateRequired: true
    },
    {
      name: "endson",
      type: "date",
      views: ["year", "month", "day"],
      required: true,
      label: "Ends On",
      className: "error-input",
      secondClassName: "form-control",
      format: dateFormat,
      helperText: dateFormat, // Helper text for date format
      indicator: "end",
      minDate: true,
      useStateRequired: true
    },
    {
      name: "description",
      placeholder: "", // Empty placeholder for textarea
      helperText: "Enter description", // Helper text for above the field
      type: "textarea",
      required: false,
      label: "Description",
      className: "form-control"
    }
  ];

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAllService(setLoading));
    if (isAiPath) {
      dispatch(getConfig());
    }
    dispatch(getAllAttribute(setLoading));
  }, [dispatch]);

  const options = ServiceOptions();
  const eventOptions = EventOptions();
  const provisionalAttribute = useSelector(
    (state) => state.Provisional.provisional
  );
  const provisionOptions = getProvisionOptions(provisionalAttribute).provisionalItems;
  const usageoptions = getProvisionOptions(provisionalAttribute).usageItems;

  const onSubmit = (values) => {
    createJsonObj(values, state, AddService);
  };

  const AddService = (jsonObj) => {
    if (!isEdit) {
      dispatch(addService(jsonObj, setLoading, navigate));
    } else {
      dispatch(editService(jsonObj, serviceCode, setLoading, navigate))
    }
  };

  const serviceOptions = [
    {
      name: "eventConfigurations",
      value: "Service",
      options: eventOptions
    },
    {
      name: "services",
      value: "Service",
      options: options
    }
  ]
  useEffect(() => {
    if ((isClone || isEdit) && serviceCode) {
      dispatch(getServiceByCode(setLoading, serviceCode, serviceOptions, setState, isEdit, setAddserviceuse, setFormInitialValues));
    }
  }, [isClone, isEdit]);

  useEffect(() => {
    if (isClone) {
      setTitle(PAGE_TITLES.CLONE_SERVICE)
    }
    else if (isEdit) {
      setTitle(PAGE_TITLES.EDIT_SERVICE)
    }
    else {
      setTitle(PAGE_TITLES.ADD_SERVICE)
    }
  }, [isClone, isEdit])

  useEffect(() => {
    if (isCreate) {
      setEnableReinitialize(true)
    }
  }, [isCreate])

  return (
    <React.Fragment>
      <div className={!isAiPath ? "page-content bg-white" : "pb-5"}>
        <Formik
          validationSchema={(values) => validationSchema(values, state)}
          initialValues={isAiPath ? initialAIServiceValues.initialAIServiceValues : formInitialValues}
          onSubmit={async (values) => {
            if (
              values.name !== "" &&
              values.code !== "" &&
              values?.startsOn !== "" &&
              values.endson !== ""
            ) {
              onSubmit(values);
            }
          }}
          enableReinitialize={true}
        >
          {({
            handleChange,
            handleBlur,
            handleSubmit,
            errors,
            touched,
            values,
            setFieldValue,
            setFieldTouched,
            setTouched,
            isValid,
            dirty,
            resetForm,
          }) => (
            <Form
              id="csms"
              className="needs-validation"
              onSubmit={handleSubmit}
            >
              <Container fluid>
                {isAiPath ? null :
                  <BreadCrumb title={title} pageTitle={PAGE_TITLES.SERVICE_LIST} />
                }
                <ToastContainer position="top-center" />
                <div className="listingjs-table " id="customerList">
                  <div className="live-preview">
                    <div className="align-items-center d-flex mb-3 ">
                      <h4 className="card-title mb-0 flex-grow-1">{isEdit ? "Edit Service" : isClone ? "Clone Service" : "Add Service"}</h4>
                    </div>
                    <div className="border rounded-1 p-3">
                      <div className=''>
                        <CardBody>
                          <Row className="gy-2 pt-1 pb-2 ">
                            {formFields.filter(field => {
                              // Set disable property based on edit mode
                              field.disable = false
                              if (isEdit && (field.name === "name" || field.name === "code" || field.name === "eventConfigurations")) {
                                field.disable = true
                              }
                              // Hide services field if not bundle
                              if (field.name === "services" && !state) {
                                return false
                              }
                              return true
                            }).map((field, fieldIndex) => (
                              <Col
                                xxl={field.name === "description" ? 12 : 3}
                                md={field.name === "description" ? 12 : 6}
                                key={fieldIndex}
                              >
                                <FormGroup>
                                  {/* Handle labels for non-switch fields and custom switch */}
                                  {(field.type !== "switch" || (field.type === "switch" && field.customLayout)) && (
                                    <>
                                      <LabelText
                                        htmlFor={field.name}
                                        className={field.required ? "text-danger" : ""}
                                        displayText={field.label}
                                        important={field.required ? "*" : ""}
                                      />
                                      {field.type !== "switch" && (
                                        <LabelText
                                          htmlFor={field.name}
                                          classLabelName={`d-block ms-0 rv-sub-label ${touched[field.name] && errors[field.name]
                                            ? "rv-label-danger"
                                            : "rv-label-muted"
                                            }`}
                                          displayText={
                                            touched[field.name] && errors[field.name]
                                              ? errors[field.name]
                                              : field.helperText || dateFormat // Use helperText instead of placeholder
                                          }
                                        />
                                      )}
                                    </>
                                  )}
                                  <RenderField
                                    field={field}
                                    handleChange={handleChange}
                                    handleBlur={handleBlur}
                                    values={values}
                                    touched={touched}
                                    errors={errors}
                                    setStartDate={setStartDate}
                                    startDate={startDate}
                                    setFieldTouched={setFieldTouched}
                                    setIsChecked={setState}
                                    isChecked={state}
                                    setFieldValue={setFieldValue}
                                    options={serviceOptions}
                                  />
                                </FormGroup>
                              </Col>
                            ))}
                          </Row>
                        </CardBody>
                      </div>
                      <Col xl={12}>
                        <div className="pt-2">
                          <Attribute
                            values={values}
                            touched={touched}
                            errors={errors}
                            setFieldValue={setFieldValue}
                            setFieldTouched={setFieldTouched}
                            initialValues={initialValues}
                            setTouched={setTouched}
                            handleChange={handleChange}
                            provisonalAttribute={provisionalAttribute}
                            provisionOptions={provisionOptions}
                            usageoptions={usageoptions}
                            selectedAttributeName={selectedAttributeName}
                            setSelectedAttributeName={setSelectedAttributeName}
                            formInitialValues={formInitialValues}
                            isEdit={isEdit}
                          />
                        </div>
                      </Col>
                    </div>
                    <Row lg={6} className=" justify-content-end  mt-4">
                      <div className="live-preview">
                        <div className="d-flex justify-content-end gap-2 mb-5">
                          <CommonButton
                            outline={true}
                            className={
                              "btn-label rv-secondary-btn rounded-1 px-1 ps-3 py-1  w-md-auto text-nowrap"
                            }
                            color={"main-color"}
                            type={"reset"}
                            buttonAction={() => navigate('/service')}
                            buttonText={"Cancel"}
                            icon={
                              <i
                                className="ri-close-line label-icon align-middle fs-16 me-2"
                                style={{ transform: "scaleX(-1)", borderLeft: "1px solid" }}
                              ></i>
                            }
                            btnTxtClsName={"px-2 ps-3 ms-2 me-1 fw-bold"}
                          />
                          <CommonButton
                           className={
                            "btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-md-auto text-nowrap"
                          }
                            color={"main-color"}
                            type={'submit'}
                            buttonText={"Save"}
                            buttonAction={handleSubmit}
                            icon={<i className="ri-save-line label-icon align-middle fs-16 me-2"></i>}
                            btnTxtClsName={"px-2 ps-3 ms-2 me-1 fw-bold"}
                          />
                        </div>
                      </div>
                    </Row>
                  </div>
                </div>
              </Container>
            </Form>
          )}
        </Formik>
        {loading && <Loader />}
      </div>
    </React.Fragment>
  );
}